import React, { useState } from 'react';

import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { useCopilotContext } from '../../contexts/CopilotContext';
import { IDocument } from '@homeporter/types';
import { useKnowledgeBaseStyles } from './styles';
import { baseUrl } from '../../utils/helpers';

type formTypes = '' | 'BOOKS' | 'MANUALS' | 'CHECKLISTS' | 'FORMS';

interface DocumentsProps {
  selectDocument: (document: IDocument) => void;
  viewAll: formTypes;
  setViewAll: (viewAll: formTypes) => void;
  documentList: IDocument[];
  title: string;
}

const Documents = ({
  selectDocument,
  viewAll,
  setViewAll,
  documentList: documentList,
  title,
}: DocumentsProps) => {
  const styles = useKnowledgeBaseStyles();

  return (
    <>
      <Box padding={'1rem'} display={'flex'} justifyContent={'space-between'}>
        <Typography fontWeight={500}>{title}</Typography>
        {!viewAll ? (
          <Button onClick={() => setViewAll(title.toUpperCase() as formTypes)}>
            <Typography
              fontSize={'0.8rem'}
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
              }}>
              View All
            </Typography>
          </Button>
        ) : (
          documentList.length > 0 && (
            <Button onClick={() => setViewAll('')}>
              <Typography fontSize={'0.8rem'} sx={styles.backArrow}>
                <ArrowBack /> Back
              </Typography>
            </Button>
          )
        )}
      </Box>
      <Grid sx={styles.grid} container spacing={4}>
        {(viewAll ? documentList : documentList.slice(0, 6)).map(
          (document, index) => (
            <Grid
              id={`book-item-${index}`}
              sx={styles.gridItem}
              item
              xs={4}
              key={index}>
              <Box
                sx={{
                  ...styles.document_item,
                  fontSize: document.title.length < 18 ? '0.8rem' : '0.7rem',
                }}
                onClick={() => selectDocument(document)}>
                <img
                  src={
                    document.type === 'FORM'
                      ? baseUrl(document.images[0])
                      : `${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/${document.key}/img/${document.images[0]}`
                  }
                  alt={`${document.title} cover`}
                  style={styles.img}
                />
                <div>{document.title}</div>
              </Box>
            </Grid>
          ),
        )}
      </Grid>
    </>
  );
};

interface DocumentListProps {
  setSelectedDocument: (document: IDocument) => void;
}

const DocumentList = ({ setSelectedDocument }: DocumentListProps) => {
  const { bookList, manualList, checklistList, formList, setViewDocument } =
    useCopilotContext();
  const [viewAll, setViewAll] = useState<formTypes>('');

  const handleSelectDocument = (document: IDocument) => {
    setViewDocument({ ...document });
    setSelectedDocument(document);
  };

  /*
  const textRef = useRef<HTMLDivElement>(null);
  const [fontSize, setFontSize] = useState('0.5rem');

  useEffect(() => {
    const adjustFontSize = () => {
      if (textRef.current) {
        const containerHeight = textRef.current.offsetHeight;
        const scrollHeight = textRef.current.scrollHeight;

        if (scrollHeight > containerHeight) {
          setFontSize('0.3rem');
        } else {
          setFontSize('0.8rem');
        }
      }
    };

    adjustFontSize();
    window.addEventListener('resize', adjustFontSize);

    return () => window.removeEventListener('resize', adjustFontSize);
  }, [document.title]);
  */

  return (
    <>
      {(!viewAll || viewAll === 'BOOKS') && bookList.length > 0 && (
        <Documents
          viewAll={viewAll}
          setViewAll={setViewAll}
          documentList={bookList}
          title={'Books'}
          selectDocument={handleSelectDocument}
        />
      )}
      {!viewAll && manualList.length > 0 && (
        <Divider sx={{ marginTop: '1rem', marginBottom: '1rem' }} />
      )}
      {(!viewAll || viewAll === 'MANUALS') && manualList.length > 0 && (
        <Documents
          viewAll={viewAll}
          setViewAll={setViewAll}
          documentList={manualList}
          title={'Manuals'}
          selectDocument={handleSelectDocument}
        />
      )}
      {!viewAll && checklistList.length > 0 && (
        <Divider sx={{ marginTop: '1rem', marginBottom: '1rem' }} />
      )}
      {(!viewAll || viewAll === 'CHECKLISTS') && checklistList.length > 0 && (
        <Documents
          viewAll={viewAll}
          setViewAll={setViewAll}
          documentList={checklistList}
          title={'Checklists'}
          selectDocument={handleSelectDocument}
        />
      )}
      {!viewAll && formList.length > 0 && (
        <Divider sx={{ marginTop: '1rem', marginBottom: '1rem' }} />
      )}
      {(!viewAll || viewAll === 'FORMS') && formList.length > 0 && (
        <Documents
          viewAll={viewAll}
          setViewAll={setViewAll}
          documentList={formList}
          title={'Forms'}
          selectDocument={handleSelectDocument}
        />
      )}{' '}
    </>
  );
};

export default DocumentList;
